import './styles.scss';

export { default } from 'rc-collapse';
